import useUserProfile from "hooks/useUserProfile";
import {
  Clock12Icon,
  Contact2Icon,
  DollarSign,
  LocateIcon,
  MessageCircleIcon,
  PhoneCallIcon,
} from "lucide-react";
import { Link } from "react-router-dom";
import { MyndaType } from "shared";
import { Booking, Invoice } from "types/booking.interface";
import { formatCurrency, formatDate, nairaSymbol } from "utills/helper";

interface Props {
  invoice: Invoice;
}
export function InvoiceCard({ invoice }: Props) {
  const { data: employer } = useUserProfile(invoice?.invoiceFor?._id);
  // @ts-expect-error error
  const { data: mynda } = useUserProfile(invoice?.mynda?.user);

  if (!invoice) return null;

  const getSubTotal = () => {
    const transport = invoice?.transportationFee || 0;
    const agencyFee = invoice?.chargedFee || 0;
    const laboratoryTest = invoice?.labTest ? invoice?.labTest?.amount : 0;

    let subTotal = agencyFee + laboratoryTest;

    if (invoice?.booking?.bookingType === MyndaType.LeaveIn) {
      subTotal = subTotal + transport;
    }

    return subTotal;
  };

  const getTotal = () => {
    const subTotal = getSubTotal();

    return subTotal;
  };
  return (
    <div className=" bg-white shadow-sm flex flex-col gap-2 p-3 rounded-md h-[100%]">
      <h1 className="text-lg">Invoice Summary</h1>
      <div className="flex flex-col my-2">
        <p>Invoice Number</p>
        <p className=" text-sm font-normal text-gray-400">
          #{invoice?.invoiceNumber}
        </p>
      </div>
      <div className="flex flex-col my-2">
        <p>Status</p>
        <p className=" text-sm font-normal text-gray-400">
          {invoice?.status}
          {/* {nairaSymbol}{formatCurrency(invoice.)} */}
        </p>
      </div>
      <div className="flex flex-col my-2">
        <p>Issue Date</p>
        <p className=" text-sm font-normal text-gray-400">
          {formatDate(invoice.createdAt)}
          {/* {nairaSymbol}{formatCurrency(invoice.)} */}
        </p>
      </div>

      <div className="flex flex-col my-2">
        <p>Transportation Fee</p>
        <p className=" text-sm font-normal text-gray-400">
          {nairaSymbol}
          {formatCurrency(invoice?.transportationFee ?? "")}
        </p>
      </div>

      <div className="flex flex-col my-2">
        <p>Commission Fee</p>
        <p className=" text-sm font-normal text-gray-400">
          {nairaSymbol}
          {formatCurrency(invoice?.chargedFee ?? "")}
        </p>
      </div>
      <div className="flex flex-col my-2">
        <p>Lab Test</p>
        <p className=" text-sm font-normal text-gray-400">
          {nairaSymbol}
          {formatCurrency(invoice?.labTest?.amount)}
        </p>
      </div>
      <div className="flex flex-col ">
        <p>Total</p>
        <p className=" text-sm font-normal text-gray-400">
          {nairaSymbol}
          {formatCurrency(getTotal())}
        </p>
      </div>
      <div className="flex flex-col gap-3">
        <h4 className="text-base text-gray-500 mt-4">Employer Details</h4>
        <Link
          className=" text-custom-500"
          to={`/pages-account/${invoice?.invoiceFor._id}`}
        >
          {employer?.data?.user?.firstName} {employer?.data?.user?.lastName}
        </Link>

        <div className="flex flex-wrap items-center gap-x-8 gap-y-1">
          <div className="flex min-w-0 items-center gap-2 text-gray-400">
            <PhoneCallIcon />
            <span>{employer?.data?.user?.phoneNumber},</span>
          </div>
          <div className="flex min-w-0 items-center gap-2 text-gray-400">
            <MessageCircleIcon />
            <a className="break-all" href={`mailto:${employer?.data?.user?.email}`}>
              {employer?.data?.user.email},
            </a>
          </div>
        </div>

        {/* <div className="flex min-w-0 items-center gap-2 text-gray-400">
            <Contact2Icon />
            <span>
              Registered: {new Date(booking?.bookedBy.createdAt).toDateString()}
            </span>
          </div> */}
        <div className=" flex flex-wrap gap-4 mt-3 bg-[#F2FFFA] p-2">
          <div>
            <img
              src={employer?.data?.profilePicture?.url}
              className=" w-[80px] h-[131px] object-cover rounded-md"
            />
            <p className="text-sm font-medium text-center">
              {invoice?.invoiceFor?.status}
            </p>
          </div>
        </div>
      </div>

      <h4 className="text-base text-gray-500 mt-4">Mynda Details</h4>

      <div className=" flex flex-wrap gap-4 p-2">
        <img
          src={invoice?.mynda?.profilePicture?.url}
          className=" w-[80px] h-[131px] object-cover rounded-md"
        />
        <div className="flex flex-col gap-3">
          <div>
            <p>{mynda?.data?.mynda?.title}</p>
            <Link
              className=" text-custom-500"
              to={`/pages-account/${mynda?.data?.user._id}`}
            >
              {mynda?.data?.user?.firstName} {mynda?.data?.user?.lastName}
            </Link>
          </div>
          <div className="flex flex-wrap items-center gap-x-8 gap-y-1">
            <div className="flex min-w-0 items-center gap-2 text-gray-400">
              {nairaSymbol}
              {formatCurrency(mynda?.data?.mynda?.salaryExpectations! || 0)}
            </div>
            <div className="flex min-w-0 items-center gap-2 text-gray-400">
              <PhoneCallIcon />
              <span>{mynda?.data?.user?.phoneNumber},</span>
            </div>
          </div>

          <div className=" flex flex-wrap items-center gap-x-8 gap-y-1 text-gray-400">
            <div className="flex min-w-0 items-center gap-2 text-gray-400">
              <MessageCircleIcon />
              <a className="break-all" href={`mailto:${mynda?.data?.user?.email}`}>
                {mynda?.data?.user?.email},
              </a>
            </div>

            <div className="flex min-w-0 items-center gap-2 text-gray-400">
              <LocateIcon />
              <span>
                {invoice?.mynda?.state}, {invoice?.mynda?.lga}
              </span>
            </div>
          </div>

          {/* <div className="flex min-w-0 items-center gap-2 text-gray-400">
            <Clock12Icon />
            <span>Created: {new Date(invoice?.createdAt).toDateString()}</span>
          </div> */}
        </div>
      </div>
    </div>
  );
}
